export default "__VITE_PUBLIC_ASSET__ada18c9e__"